export default __webpack_public_path__ + "static/media/modrateSmile.5947cf36.svg";